
import React from 'react';
import { Link } from 'react-router-dom';
import './Ecommerce.scss';

// Import any necessary assets
// import heroImage from '../../assets/images/ecommerce-hero.jpg';
// import supportAvatar from '../../assets/images/support-avatar.png';

// SVG Icon Components
const icons = {
  shoppingCart: (
    <svg width="48" height="48" fill="none" viewBox="0 0 48 48">
      <rect x="8" y="16" width="32" height="24" rx="4" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <path d="M16 16V12a8 8 0 0 1 16 0v4" stroke="#3A5EAA" strokeWidth="2"/>
      <circle cx="18" cy="32" r="2" fill="#3A5EAA"/>
      <circle cx="30" cy="32" r="2" fill="#3A5EAA"/>
    </svg>
  ),
  search: (
    <svg width="48" height="48" fill="none" viewBox="0 0 48 48">
      <circle cx="20" cy="20" r="10" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <path d="M28 28L36 36" stroke="#3A5EAA" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  users: (
    <svg width="48" height="48" fill="none" viewBox="0 0 48 48">
      <circle cx="18" cy="18" r="6" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <circle cx="30" cy="18" r="6" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <path d="M10 36a8 8 0 0 1 16 0" stroke="#3A5EAA" strokeWidth="2"/>
      <path d="M22 36a8 8 0 0 1 16 0" stroke="#3A5EAA" strokeWidth="2"/>
    </svg>
  ),
  bell: (
    <svg width="48" height="48" fill="none" viewBox="0 0 48 48">
      <path d="M24 12v-4" stroke="#3A5EAA" strokeWidth="2"/>
      <path d="M34 30v-10a10 10 0 0 0-20 0v10l-4 4h28l-4-4z" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <path d="M20 34a4 4 0 0 0 8 0" stroke="#3A5EAA" strokeWidth="2"/>
    </svg>
  ),
  headset: (
    <svg width="48" height="48" fill="none" viewBox="0 0 48 48">
      <path d="M14 22v-2a10 10 0 0 1 20 0v2" stroke="#3A5EAA" strokeWidth="2"/>
      <rect x="8" y="22" width="6" height="12" rx="2" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <rect x="34" y="22" width="6" height="12" rx="2" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <path d="M34 30h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-10" stroke="#3A5EAA" strokeWidth="2"/>
    </svg>
  ),
  scale: (
    <svg width="48" height="48" fill="none" viewBox="0 0 48 48">
      <rect x="8" y="8" width="32" height="32" rx="2" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <path d="M8 8l32 32M8 40L40 8" stroke="#3A5EAA" strokeWidth="2"/>
      <circle cx="24" cy="24" r="4" fill="#3A5EAA"/>
    </svg>
  ),
  share: (
    <svg width="48" height="48" fill="none" viewBox="0 0 48 48">
      <circle cx="36" cy="12" r="6" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <circle cx="12" cy="24" r="6" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <circle cx="36" cy="36" r="6" stroke="#3A5EAA" strokeWidth="2" fill="#fff"/>
      <path d="M17 21L31 15M17 27l14 6" stroke="#3A5EAA" strokeWidth="2"/>
    </svg>
  ),
};

const Ecommerce = () => {
  return (
    <div className="ecommerce-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-image">
          {/* Replace with actual image */}
          <img 
            src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" 
            alt="E-commerce illustration" 
          />
        </div>
        <div className="hero-content">
          <h1>AI Chatbots for E-Commerce</h1>
          <p>Implement a specialized eCommerce chatbot into your online sales strategy for intelligent, automated, and improved customer service.</p>
          <Link to="/contact" className="cta-button">Request Demo</Link>
        </div>
      </section>

      {/* Features Grid */}
      <section className="features-section">
        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-icon">
              {icons.shoppingCart}
            </div>
            <h3>Direct Purchasing</h3>
            <p>Simplify the sales chain by giving customers the option to buy directly within the chat.</p>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              {icons.search}
            </div>
            <h3>Product Catalog Browsing</h3>
            <p>Customers can intuitively browse products, view images, and more using the chatbot interface.</p>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              {icons.users}
            </div>
            <h3>Engage with New Customers</h3>
            <p>Automate the building and nurturing of customer relationships through social media channels.</p>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              {icons.bell}
            </div>
            <h3>Customer Notifications</h3>
            <p>Send automated notifications about deliveries, product recommendations, offers and more.</p>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              {icons.headset}
            </div>
            <h3>Powerful Customer Support</h3>
            <p>24/7 AI-enabled support to provide an enhanced purchasing experience for your customers.</p>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              {icons.scale}
            </div>
            <h3>Scalable by Design</h3>
            <p>Scalable to match your business, whatever its size, always with the same high level of service.</p>
          </div>

          <div className="feature-item">
            <div className="feature-icon">
              {icons.share}
            </div>
            <h3>Share across social channels</h3>
            <p>Simplified sharing so customers can spread the word and promote your business for you.</p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="about-content">
          <p>
            Skil.AI chatbots for ecommerce utilize powerful machine learning algorithms and language processing to provide conversational AI support, specifically designed for ecommerce operations. Improve and automate your online store's customer service, reduce the workload of your support teams, and boost the efficiency of your ecommerce business.
          </p>
        </div>
        <div className="about-image">
          {/* Replace with actual illustration */}
          <img 
            src="https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" 
            alt="Person using a laptop" 
          />
        </div>
      </section>

      {/* Secondary CTA */}
      <section className="secondary-cta">
        <div className="cta-avatar">
          {/* Replace with actual avatar */}
          <img 
            src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" 
            alt="Customer support agent" 
          />
        </div>
        <div className="cta-content">
          <h2>Try it today</h2>
          <p>Experience AI-powered virtual assistant first hand !</p>
          <Link to="/contact" className="cta-button">Request Demo</Link>
        </div>
      </section>
    </div>
  );
};

export default Ecommerce;
